import React, { Component } from 'react';
import classnames from 'classnames';
import { defineMessages, injectIntl } from 'react-intl';
import AdvancedForm from './advanced-form';
import caret from './dropdown-caret-12.svg';
import './index.scss';

const messages = defineMessages({
  advancedSearch: {
    id: '',
    description: 'Alternative text for the advanced search toggle icon',
    defaultMessage: 'Advanced Search',
  },
});

class AdvancedSearch extends Component {
  state = {
    pendingSearch: false,
    query: '',
    open: false,
  };

  handleQuery = (event) =>
    this.setState({
      query: event.target.value,
    });

  handleToggle = () =>
    this.setState({
      open: !this.state.open,
    });

  handleAdvancedSearch = (parameters) => {
    const parts = [parameters.contains];

    if (parameters.filter) {
      parts.push(`filter:${parameters.filter}`);
    }

    if (parameters.signer) {
      parts.push(`to:"${parameters.signer}"`);
    }
    if (parameters.sender) {
      parts.push(`from:"${parameters.sender}"`);
    }
    if (parameters.created) {
      parts.push(`created:${parameters.created}`);
    }
    if (parameters.owner) {
      parts.push(`owner:"${parameters.owner}"`);
    }
    if (parameters.testMode) {
      parts.push('test_mode:true');
    }

    this.setState({
      pendingSearch: true,
      open: false,
      query: parts.join(' ').trim(),
    });
  };

  componentDidUpdate() {
    // The search needs to happen AFTER the DOM updated
    if (this.state.pendingSearch) {
      this.setState({ pendingSearch: false });

      if (typeof this.props.onSearch === 'function') {
        this.props.onSearch();
      }
    }
  }

  render() {
    const { onSearch, siteCode, includeAllTeam, ...inputProps } = this.props;

    return (
      <div className="advanced-search">
        <input
          {...inputProps}
          className={classnames('query', this.props.className)}
          type="text"
          value={this.state.query}
          onChange={this.handleQuery}
        />
        <a className="advanced-search__toggle" onClick={this.handleToggle}>
          <img
            src={caret}
            alt={this.props.intl.formatMessage(messages.advancedSearch)}
          />
        </a>
        {this.state.open ? (
          <AdvancedForm
            onSearch={this.handleAdvancedSearch}
            siteCode={siteCode}
            includeAllTeam={includeAllTeam}
          />
        ) : null}
      </div>
    );
  }
}

export default injectIntl(AdvancedSearch);
